export const AddeparInventoryStatus = {
  PENDING: "PENDING",
  ONBOARDED: "ONBOARDED",
  IGNORED: "IGNORED",
};

export const normalizeStatus = (status) => {
  if (status === 0 || status === "0") return AddeparInventoryStatus.PENDING;
  if (status === 1 || status === "1") return AddeparInventoryStatus.ONBOARDED;
  if (status === 2 || status === "2") return AddeparInventoryStatus.IGNORED;

  const value = String(status || "").toLowerCase();
  if (value === "onboarded") return AddeparInventoryStatus.ONBOARDED;
  if (value === "ignored") return AddeparInventoryStatus.IGNORED;
  return AddeparInventoryStatus.PENDING;
};

/** API enum: 0 = Pending, 1 = Onboarded, 2 = Ignored */
export const toApiStatus = (status) => {
  const normalized = normalizeStatus(status);
  if (normalized === AddeparInventoryStatus.ONBOARDED) return 1;
  if (normalized === AddeparInventoryStatus.IGNORED) return 2;
  return 0;
};

export const normalizeInventoryRow = (row) => {
  const addeparInventoryId =
    row?.addeparInventoryId ?? row?.id ?? row?.addeparEntityId ?? "";
  return {
    ...row,
    id: addeparInventoryId,
    addeparInventoryId,
    addeparEntityId: row?.addeparEntityId ?? "",
    name: row?.name ?? "",
    accountNumber: row?.accountNumber ?? row?.account ?? row?.accountNum ?? "",
    createdAt: row?.createdAt ?? row?.created ?? row?.date ?? "",
    status: normalizeStatus(row?.status),
  };
};

export const normalizeInventoryList = (rows) =>
  (Array.isArray(rows) ? rows : []).map(normalizeInventoryRow);

export const countPendingInventory = (inventory) =>
  (Array.isArray(inventory) ? inventory : []).filter(
    (row) => normalizeStatus(row?.status) === AddeparInventoryStatus.PENDING
  ).length;
